<template>
    <div class="row">
        <div class="col-12">
            <div class="pull-right mr-4 mb-4 mt-4">
                <a class="btn btn-brand mr-4" :href="route('application-activities.export', {'relation': entityId})">
                    <i class="fa fa-lg fa-download"/>
                    {{ uLang('app.export', { type: uLang('app.application_activities') }) }}
                </a>

                <a v-if="canCreate" class="btn btn-brand" @click.prevent="showApplicationActivitiesForm = true">
                    <i class="fa fa-lg fa-plus"/>
                    {{ uLang('app.add_type', { type: uLang('app.application_activity') }) }}
                </a>
            </div>

            <application-activities-table
                :forceRefresh="forceRefresh"
                :entityId="entityId"
                @refreshed="stopRefreshing"
            />

            <portal v-if="showApplicationActivitiesForm" to="modals">
                <b-modal
                    ref="applicationActivitiesModal"
                    v-model="showApplicationActivitiesForm"
                    :close-on-backdrop="false"
                    :close-on-esc="false"
                    :hideFooter="true"
                    :title="uLang('app.add_type', { type: uLang('app.application_activity') })"
                    class="application-activities-modal-lg"
                    size="lg"
                >
                    <application-activities-form
                        :entityId="entityId"
                        @applicationActivityCreated="handleApplicationActivityCreated"
                    />
                </b-modal>
            </portal>
        </div>
    </div>
</template>
<script>
    import { ApplicationActivitiesTable } from "~/components/tables";
    import { ApplicationActivitiesForm } from "~/components/forms";
    import { mapGetters } from 'vuex'

    export default {
        name: "ApplicationActivitiesTab",
        components: {
            ApplicationActivitiesTable,
            ApplicationActivitiesForm,
        },
        props: {
            entityId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                showModal: false,
                forceRefresh: false,
                showApplicationActivitiesForm: false,
            }
        },
        computed: {
            ...mapGetters([
                'authUser',
            ]),
            canCreate() {
                return $hasRole('super_admin') || $can('create-application-activities') || this.entityId === this.authUser.id
            }
        },
        methods: {
            handleApplicationActivityCreated() {
                this.showApplicationActivitiesForm = false
                this.forceRefresh = true;
            },
            stopRefreshing() {
                this.forceRefresh = false;
            },
        },
    };
</script>
<style lang="css">
    .application-activities-modal-lg {
        max-width: 1000px;
    }
</style>
